import styled from 'styled-components';

interface StyledProps {
  hasList?: boolean;
}

export const Container = styled.div.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasList }) => (hasList ? 116 : 0)}px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: ${({ hasList }) => (hasList ? 75 : 0)}px;
  }
`;

export const List = styled.ol`
  display: flex;
  margin-bottom: 32px;
  &:last-child {
    margin-bottom: 50px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
